export const payrexxInstances: Record<string, string | undefined> = {
  DE: process.env.REACT_APP_PAYREXX_INSTANCE_DE,
  AT: process.env.REACT_APP_PAYREXX_INSTANCE_AT,
};

export const getPayrexxInstance = (countryCode: string): string => {
  return payrexxInstances[countryCode] || "beppo-de";
};
